import script from "./ADLPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ADLPageHeader.vue?vue&type=script&setup=true&lang=js"

import "./ADLPageHeader.vue?vue&type=style&index=0&id=f5a37d3a&scoped=true&lang=css"

import exportComponent from "D:\\A-Project\\nezha_business\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5a37d3a"]])

export default __exports__